import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ActiveType } from '../../../model/activeType';
import { getActiveOverview } from '../../../redux/actions/activeActions';
import { useAppThunkDispatch } from '../../../redux/configureStore';
import { activeOverview } from '../../../redux/selectors/activeSelectors';
import Custom from './Custom';
import TenMetreWalk from './TenMetreWalk';
import TestDetailHeader from './TestDetailHeader';
import TimedUpAndGo from './TimedUpAndGo';

const TestDetail: React.FC = () => {
  const { t } = useTranslation('tests');
  const { patientId, testType } = useParams();
  const typeString = testType as keyof typeof ActiveType;
  const type: ActiveType = ActiveType[typeString];

  const dispatch = useAppThunkDispatch();
  const overview = useSelector(activeOverview);

  // The header derives its starting day from the overview's "most recent" date.
  // On a hard refresh straight onto this route the patient detail page (which
  // normally loads the overview) never mounts, so fetch it here when missing —
  // otherwise the picker would fall back to today and show no data.
  useEffect(() => {
    if (patientId && !overview) {
      dispatch(getActiveOverview(patientId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  return (
    <Box>
      <TestDetailHeader patientId={patientId} testType={type} />
      {(() => {
        switch (type) {
          case ActiveType._10MWT:
            return <TenMetreWalk />;
          case ActiveType._TUG:
            return <TimedUpAndGo />;
          case ActiveType._CTEST:
            return <Custom />;
          default:
            return <>{t('typeNotFound')}</>;
        }
      })()}
    </Box>
  );
};

export default TestDetail;
